export const getUnauthenticatedLegalRedirect = () => {
  const isAuthenticated = localStorage.getItem('access_token');
  const path = window.location.pathname;
  const hash = window.location.hash;
  
  // Check if the path is account/legal and user is not authenticated
  if (path === '/account/legal' && !isAuthenticated) {
    if (hash) {
      window.location.href = `/legal${hash}`;
      return true;
    }
  }
  
  return false;
};